<template>
  <div class="umdb-setlist">
    <b-table
      :items="items"
      :fields="fields"
      sort-by="releaseDate"
      sort-null-last
      responsive
      class="compact-table-sm"
    >
      <template v-slot:row-details="row">
        <div
          v-if="row.item.notes"
          class="mx-4"
          v-html="parseMarkdown(row.item.notes)"
        ></div>
      </template>
    </b-table>
  </div>
</template>

<script>
import markdown from "@/mixins/markdown";
import dateFormat from "@/mixins/dateFormat";

export default {
  name: "UmDbSetList",
  mixins: [markdown, dateFormat],
  data() {
    return {
      fields: [
        {
          key: "name",
          sortable: true,
        },
        {
          key: "max_players",
          label: "Max. players",
          tdClass: ["text-right"],
          thClass: ["text-right vertical"],
          sortable: true,
        },
        {
          key: "spaces_count",
          label: "Spaces",
          tdClass: ["text-right"],
          thClass: ["text-right vertical"],
          sortable: true,
        },
        {
          key: "zone_count",
          label: "Zones",
          tdClass: ["text-right"],
          thClass: ["text-right vertical"],
          sortable: true,
        },
      ],
    };
  },
  props: {
    boards: {
      type: Array,
      required: true,
    },
  },
  computed: {
    items() {
      return this.boards.map((board) => ({
        ...board,
        _showDetails: !!board.notes,
      }));
    },
  },
};
</script>

<style lang="less">
.umdb-setlist {
  .unreleased {
    font-style: italic;
  }
}
</style>
